import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';

export class DrawInsideShelfSystem extends DrawCabinetInsideElement {
    Number!: number;
}
